import { render, staticRenderFns } from "./survey-step-type-two-diabetes.vue?vue&type=template&id=47f2ab4e"
import script from "./survey-step-type-two-diabetes.vue?vue&type=script&lang=js"
export * from "./survey-step-type-two-diabetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports